import { DEFAULT_SERP_COLORS, resolveSerpColors, type SerpColors } from './serp-appearance.js';
import type { FakeEvidence } from './fakes.types.js';
import { isCompetitorTone } from './serp-indicators.js';

// Shared by the dashboard, standalone HTML and frozen Telegram PNG.
export const HEATMAP_PALETTE = {
  light: {
    background: '#FAFAFA',
    text: '#212121',
    muted: '#666666',
    border: '#E8E8E8',
    empty: '#F0F2F5',
    unavailable: '#F0F2F5',
    ...DEFAULT_SERP_COLORS,
  },
  dark: {
    background: '#222222',
    text: '#DEDEDE',
    muted: '#9E9E9E',
    border: '#424242',
    empty: '#1E1E1E',
    unavailable: '#1E1E1E',
    ...DEFAULT_SERP_COLORS,
  },
} as const;
export function heatmapPalette(mode: 'light' | 'dark', colors?: SerpColors | null) {
  return { ...HEATMAP_PALETTE[mode], ...resolveSerpColors(colors) };
}
import { SERP_CLASSIFICATION_LABELS } from './serp-classification.js';
export const HEATMAP_LABELS = {
  ...SERP_CLASSIFICATION_LABELS,
  empty: 'Нет результата',
  unavailable: 'Нет полных данных',
} as const;
export const HEATMAP_LEGEND = Object.entries(HEATMAP_LABELS).filter(([key]) => key !== 'external');
export type HeatmapTone = keyof typeof HEATMAP_LABELS;
export type HeatmapResult = FakeEvidence & {
  rank: number;
  hostname: string;
  relevance?: { noise: boolean } | null;
};
export function heatmapTone(result: HeatmapResult): HeatmapTone {
  return isCompetitorTone(result) ? 'competitor' : result.classification;
}
export function heatmapSlots<T extends HeatmapResult>(
  status: string,
  results: readonly T[],
  top: number,
): Array<{ rank: number; parts: Array<{ result: T | null; tone: HeatmapTone }> }> {
  return Array.from({ length: top }, (_, i) => {
    const rank = i + 1;
    const matches = status === 'complete' ? results.filter((r) => r.rank === rank) : [];
    return {
      rank,
      parts: matches.length
        ? matches.map((result) => ({ result, tone: heatmapTone(result) }))
        : [
            {
              result: null,
              tone: (status === 'complete' ? 'empty' : 'unavailable') as HeatmapTone,
            },
          ],
    };
  });
}
export function heatmapLabel(tone: HeatmapTone, result: HeatmapResult | null) {
  return `${HEATMAP_LABELS[tone]}${result ? ` · ${result.hostname}` : ''}${result?.relevance?.noise ? ' · Шум' : ''}`;
}
export function heatmapPattern(tone: HeatmapTone, noise = false) {
  return tone === 'unavailable' || tone === 'unknown' || tone === 'conflict' || noise;
}
